// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"bd3d13ac99b485db","7966":"6df38bd2579ac123","8179":"6df38bd2579ac123","8823":"6df38bd2579ac123","9913":"6df38bd2579ac123"}[chunkId] + ".css";
};